import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getNotification = (id) => {
  return axiosClient
    .get(`api/admin/notifications/global-notifications/${id}`)
    .then((r) => r.data);
};
